import styled from 'styled-components';
import { Form } from '@/components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledForm = styled(Form)`
  height: 100%;
  width: 100%;
  max-width: 36rem;
`;
